import cronstrue from 'cronstrue';
import { maxDate, minDate } from '../constants/constants';

export const dayDateTimeFormat = "EEE, M/d/yy h:mmaaaaa'm'";
export const standardDateTime = 'MM/dd/yy h:mm:ss a';
export const shortDateFormat = 'shortDate';
export const LESS_THAN_ONE_SECOND = '< 1s';
export const GREATER_THAN_THIRTY_DAYS = '> 30 days';

export function createDateWithUtcOffsetApplied(date: Date): Date {
    return new Date(date.getTime() - minutesToMilliseconds(date.getTimezoneOffset()));
}

function minutesToMilliseconds(minutes: number): number {
    return minutes * 60 * 1_000;
}

export function createEndOfDayDateForDay(date: Date): Date {
    const dateCopy = new Date(date);
    dateCopy.setHours(23, 59, 59, 999);
    return dateCopy;
}

export function isQueued(date: Date): boolean {
    return date.toISOString().includes(minDate);
}

export function hasNoNextRun(date: Date | null | undefined): boolean {
    return !date || date.toISOString().includes(maxDate);
}

export function isDate(value: any): value is Date {
    return value instanceof Date && !isNaN(value.valueOf());
}

export function toDate(value: string) {
    return Date.parse(value.toString());
}

/** Translate number of milliseconds into human readable description of the duration. */
export function translateMilliseconds(milliseconds: number): string {
    if (milliseconds < 1000) {
        return '< 1s';
    }

    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const humanReadableParts: string[] = [];

    if (hours > 720) {
        return GREATER_THAN_THIRTY_DAYS;
    }

    if (hours > 0) {
        humanReadableParts.push(`${hours}h`);
    }

    if (hours > 0 || minutes > 0) {
        humanReadableParts.push(`${minutes}m`);
    }

    humanReadableParts.push(`${seconds}s`);

    return humanReadableParts.join(' ');
}
